/* eslint-disable  */
//@ts-nocheck
import { add, format, isSameDay } from 'date-fns';
import { Emoji } from 'emoji-mart';
import React, { forwardRef, useEffect, useMemo, useState } from 'react';
import {
  Attachment,
  Channel,
  ChannelHeader,
  ChannelList,
  Chat,
  MessageInput,
  MessageList,
  ReactionSelector,
  ReactionSelectorProps,
  ReactionsList,
  useChannelStateContext,
  useChatContext,
  useTranslationContext,
  Window,
} from 'stream-chat-react';
import 'stream-chat-react/dist/css/index.css';
import styled from 'styled-components';
import { ChannelPreviewMessenger } from './ChannelPreview';
import { CustomEmojiPicker } from './CustomEmojiPicker';
import './stream-chat.css';
import { CustomMessage } from './Message';
import { CustomMessageInput } from './CustomMessageInput';
import {
  chatFormatDate,
  CustomReactionSelector,
  CustomReactionsList,
} from './common';
import { CustomAttachment } from './Attachment';
import emojiIcon from '/static/images/emoji.svg';
import fileUploadIcon from '/static/images/file.svg';

const Icon = styled.img`
  cursor: pointer;
`;

const dateInTheFuture = add(new Date(), { days: 1 });

const EmojiIcon = () => <Icon src={emojiIcon} />;
const FileUploadIcon = () => <Icon src={fileUploadIcon} />;

const HideableMessageInput = (props) => {
  const { channel } = useChannelStateContext();
  if (
    typeof channel.data.canMemberSendMessage !== 'undefined' &&
    !channel.data.canMemberSendMessage
  ) {
    return null;
  }
  return <MessageInput {...props} />;
};

const ChatWrapper = ({ userId }) => {
  const filters = {
    type: 'messaging',
    members: {
      $in: [userId],
    },
    last_message_at: { $lt: dateInTheFuture.toISOString() }, // filter out empty channels
  };

  const options = { state: true, presence: true, limit: 100 };
  const sort = { last_message_at: -1 };

  return (
    <div
      id="inbox"
      style={{ '--second-font': '"Source Sans Pro", sans-serif' } as any}
    >
      <ChannelList
        Preview={ChannelPreviewMessenger}
        filters={filters}
        sort={sort}
        options={options}
      />
      <Channel
        Emoji={Emoji}
        EmojiIcon={EmojiIcon}
        EmojiPicker={CustomEmojiPicker}
        FileUploadIcon={FileUploadIcon}
        Input={CustomMessageInput}
        ReactionsList={CustomReactionsList}
        ReactionSelector={CustomReactionSelector}
        Attachment={CustomAttachment}
      >
        <Window>
          <ChannelHeader />
          <MessageList
            Message={CustomMessage}
            messageActions={['flag', 'mute', 'react']}
            formatDate={chatFormatDate}
          />
          <HideableMessageInput />
        </Window>
      </Channel>
    </div>
  );
};

export const Inbox = ({ client, userId }) => {
  return (
    <Chat client={client}>
      <ChatWrapper userId={userId} />
    </Chat>
  );
};
